// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1cLHS","header":"ReportDetails_header__1PxdU","title":"ReportDetails_title__1zFlN","left":"ReportDetails_left__18PvC"};